/**
 * 使用分析 —— 展示格式化工具。
 *
 * 需求背景：有效使用时长的最小单位是「分钟」（服务端按分钟位去重），但老板看的是时/分；
 * 登录时长可能很长（含挂机），不能和有效时长用同一套「小时」精度，否则看起来一样。
 * 所以统一在这里做格式化，保证页面、导出、排行卡的数字口径与显示一致。
 */

/** 秒 → 可读时长。小于 1 分钟显示「<1 分」，避免出现大量 0。 */
export function fmtDuration(seconds, zh = true) {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  if (total <= 0) return zh ? "0 分" : "0 min";
  if (total < 60) return zh ? "<1 分" : "<1 min";
  const minutes = Math.round(total / 60);
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return zh ? `${rest} 分` : `${rest} min`;
  if (!rest) return zh ? `${hours} 小时` : `${hours} h`;
  return zh ? `${hours} 小时 ${rest} 分` : `${hours} h ${rest} min`;
}

/** 数字格式化：千分位；保留一位小数（人均指标用）。 */
export function fmtNumber(value, zh = true, digits = 0) {
  const n = Number(value) || 0;
  const fixed = Number.isInteger(n) ? n : Number(n.toFixed(digits || 1));
  return fixed.toLocaleString(zh ? "zh-CN" : "en-US");
}

/** 分钟 → 小时（图表轴用，保留一位小数）。 */
export function fmtHours(minutes) {
  return Math.round((Number(minutes) || 0) / 60 * 10) / 10;
}

/**
 * 模块名压缩：图表左侧标签宽度有限，而 MODULE_CATALOG 里有些模块名带整段使用说明
 * （例：「工程项目（销售：我的客户只读 · 售后 / 分公司销售部经理：本分公司只读）」），
 * 原样渲染会把 Y 轴撑成三四行、把柱状图挤变形。
 * 这里只做**展示层截断**：括号（含中英文）内的补充说明去掉，仍超长再截字加省略号；
 * 表格和提示框仍使用完整名称，信息不丢失。
 */
export function shortModuleName(name, max = 12) {
  const raw = String(name || "").trim();
  if (!raw) return "";
  // 去掉中英文括号里的补充说明（它们通常是权限 / 只读范围的注释，不是模块本名）。
  const cleaned = raw.replace(/[（(][^）)]*[）)]/g, "").trim() || raw;
  return cleaned.length > max ? `${cleaned.slice(0, max)}…` : cleaned;
}
